import {
	findTssHelperFnForBp,
	findTssHelperFnForErs
}                            from '@app/modules/tss/helpers/find-tss.helper';
import { TssVariant }        from '@app/modules/tss/models/tss.model';
import { TssState }          from '@app/modules/tss/store/tss.state';
import { adapterSelectors }  from '@core/store/adapter/adapter.selectors';
import { apiSelectors }      from '@core/store/api/api.selectors';
import { EntityVariantEnum } from '@models/entity.model';
import { EntityAdapter }     from '@ngrx/entity';
import {
	createFeatureSelector,
	createSelector
}                            from '@ngrx/store';
import { LoggerService }     from '@shared/services/logger.service';


export function tssSelector(
	adapter: EntityAdapter<TssVariant>,
	storeId: string,
	logger: LoggerService
) {
	const tssStateSelector = createFeatureSelector<TssState>( storeId );
	const adapterSelector = { ...adapterSelectors<TssVariant, TssState>( adapter, tssStateSelector ) };

	return {
		adapterSelector,
		...apiSelectors<TssVariant, TssState>( adapter, adapterSelector ),

		hoveredTssId: () =>
			createSelector(
				tssStateSelector,
				( state: TssState ) => state?.hoveredTssId
			),

		selectAllTssAssignedToErs: ( tssEntityId: string ) =>
			createSelector(
				adapterSelector.all,
				( tssList: TssVariant[] ) => tssList.filter( ( tss: TssVariant ) => tss.id === tssEntityId )
			),

		selectTssByIdAndEntityVariant: ( tssId: string, entityVariant: EntityVariantEnum ) =>
			createSelector(
				adapterSelector?.all,
				( tssList: TssVariant[] ) => tssList.find( ( tss: TssVariant ) => tss.id === tssId && tss.entityVariant === entityVariant )
			),

		selectTSSForErs: ( tssId: string, entityVariant: EntityVariantEnum ) =>
			createSelector(
				adapterSelector.all,
				( tssList: TssVariant[] ) => tssList.filter( ( tss: TssVariant ) => tss.id === tssId && findTssHelperFnForErs( tss, entityVariant ) )[ 0 ]
			),

		selectTSSForBP: ( businessPremisesId: string, entityVariant?: EntityVariantEnum ) =>
			createSelector(
				adapterSelector.all,
				( tssList: TssVariant[] ) => tssList.filter(
					( tss: TssVariant ) => tss.businessPremisesId === businessPremisesId && findTssHelperFnForBp( tss, entityVariant ) )
			),

		selectAllTssWithBusinessPremisesId: ( businessPremisesId: string, entityVariant?: EntityVariantEnum ) =>
			createSelector(
				adapterSelector.all,
				( tssList: TssVariant[] ) => tssList.filter( ( tss: TssVariant ) => {
					const businessPremisesIdIsMatching: boolean = tss.businessPremisesId === businessPremisesId;
					const entityVariantIsMatching: boolean = tss.entityVariant === entityVariant;

					return entityVariant
								 ? businessPremisesIdIsMatching && entityVariantIsMatching
								 : businessPremisesIdIsMatching;
				} )
			),

		selectTssListByEntityVariant: ( entityVariant: EntityVariantEnum ) =>
			createSelector(
				adapterSelector.all,
				( tssList: TssVariant[] ) => tssList.filter( ( tss: TssVariant ) => tss.entityVariant === entityVariant )
			)
	};
}

